export default async () => {
  const hero = document.querySelector<HTMLElement>('.edo_hero');
  if (hero) {
    const resizeObserver = new ResizeObserver(() => heroResizer(hero));
    resizeObserver.observe(hero);
  }

  const counter = hero?.querySelector<HTMLElement>('.edo_hero__participants__content__numbers');
  if (counter) {
    const statsResponse = await fetch('https://ag.ecodigo.fr/sapi/platform/stats');
    if (statsResponse.ok) {
      const { nbRegistration } = await statsResponse.json();
      counter.innerHTML = '';
      const nbDigits = nbRegistration.toString().length;
      if (nbDigits <= 5) {
        const zerosToAdd = 5 - nbDigits;
        for (let i = 0; i <= zerosToAdd; i += 1) {
          counter.insertAdjacentHTML(
            'afterbegin',
            '<span class="edo_hero__participants__content__numbers__value">0</span>',
          );
        }
      }
      counter.insertAdjacentHTML(
        'beforeend',
        nbRegistration
          .toString()
          .split('')
          .map((digit: string) => `<span class="edo_hero__participants__content__numbers__value">${digit}</span>`)
          .join(''),
      );
    }
  }
};

const heroResizer = (hero: HTMLElement) => {
  const imageContainer = hero.querySelector<HTMLElement>('.edo_hero__image-container');
  const image = imageContainer?.querySelector<HTMLElement>('.edo_hero__image-container__inner');
  if (!imageContainer || !image) return;

  const computedStyle = window.getComputedStyle(imageContainer);
  const aspectRatio = computedStyle.getPropertyValue('aspect-ratio');

  if (aspectRatio !== 'auto') {
    const { height } = image.getBoundingClientRect();
    const nextElement = hero.nextElementSibling;
    (nextElement as HTMLElement)?.style.setProperty('padding-top', `calc(${height}px - 5.5rem)`);
  } else {
    (hero.nextElementSibling as HTMLElement)?.style.removeProperty('padding-top');
  }
};
